var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container col-lg-8 col-md-8 partner-edit-subscription pb-4 mb-4"},[_c('EditPartnerSubscription',{on:{"submit":_vm.editPartnerSubscription}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }